import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Container, Grid, Card, Header, Loader } from 'semantic-ui-react';
import { UniversalLink, Image } from '@plone/volto/components';
import { searchContent } from '@plone/volto/actions';
import { flattenToAppURL } from '@plone/volto/helpers';
import { isEmpty, map } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faCalendar } from '@fortawesome/free-regular-svg-icons';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { formatDate, formatTime } from '../../helpers';
import { Icon } from '../';
import moment from 'moment';


const RelatedEquipmentEvents = props => {
  const content = props;
  const dispatch = useDispatch();
  const events = useSelector((state) => state.search.subrequests.relatedEquipmentEvents?.items);
  const isLoading = useSelector((state) => state.search.subrequests.relatedEquipmentEvents?.loading);

  useEffect(() => {
    if (!content?.UID) return;

    const query = {
      portal_type: ['Event'],
      review_state: 'published',
      related_equipment: content.UID,
      sort_on: 'start',
      b_size: 3,
      metadata_fields: ['start', 'end', 'location', 'Subject', 'hasPreviewImage'],
    };

    query['end.query'] = [moment().format('YYYY/MM/DD HH:mm')]
    query['end.range'] = 'min'

    dispatch(searchContent('/', query, 'relatedEquipmentEvents'));
  }, [dispatch, content?.UID]);


  const getEventDate = function (start, end) {
    const startDay = formatDate(start);
    const endDay = formatDate(end);

    const optionsFullTime = { year: 'numeric', month: '2-digit', day: '2-digit' };

    if (startDay === endDay) {
      return (
        <time dateTime={start} className='d-flex align-items-center'>
          <FontAwesomeIcon className="eventsItem__icon me-2" icon={faCalendar} />
          <span suppressHydrationWarning>{formatDate(start, optionsFullTime)}</span>
        </time>
      );
    }

    return (
      <>
        <time suppressHydrationWarning dateTime={start} className='d-flex align-items-center '>
            <FontAwesomeIcon className="eventsItem__icon me-2" icon={faCalendar} />
            <span suppressHydrationWarning>{formatDate(start, optionsFullTime)}</span>
          
        </time > &mdash;
        <time suppressHydrationWarning dateTime={end} className='d-flex align-items-center'>
          <span className="eventsItem__date__day"> 
            <span suppressHydrationWarning>{formatDate(end, optionsFullTime)}</span>
          </span>
        </time>
      </>
    );
  };

  if (isLoading) return <div className="py-4"><Loader active inline="centered" /></div>;
  if (isEmpty(events)) return null;

  return (
    <div className="newsListing__wrapper relatedEquipmentEvents py-4">
      <Header as="h3" className="relatedContent__title h5 mb-4">
        <FormattedMessage id="Related events" defaultMessage="Related events" />
      </Header>
      <Container className="events eventsListing">
        <Grid>
          <Grid.Row columns={12} as="ul" className="list-unstyled eventsList my-0">
            {events.map((item) => (
              <Grid.Column
                className="mb-4"
                mobile={12}
                tablet={6}
                computer={4}
                key={item['@id']}
                as="li"
              >
                <Card fluid as="article" className="eventsItem position-relative">
                  {item?.hasPreviewImage && (
                    <div className="eventsItem__figure">
                      <Image
                        item={item}
                        loading="lazy"
                        alt=""
                        className="eventsItem__img m-0 image"
                        sizes="(max-width: 767px) 100vw, (max-width: 991px) 50vw, 33.33vw"
                      />
                    </div>
                  )}

                  <Card.Content className="eventsItem__text">
                    {item.event_subjects?.length > 0 && (
                      <Card.Meta className="eventsItem__meta mb-3">
                        <ul className="list-unstyled eventsItem__meta__list mt-0 mb-2">
                          {map(item.event_subjects.slice(0, 1), (sub) => (
                            <li key={sub}>
                              <span className="newsItem__subject__item">{sub}</span>
                            </li>
                          ))}
                        </ul>
                      </Card.Meta>
                    )}

                    <Card.Header className="eventsItem__title" as="h2">
                      <UniversalLink
                        className="eventsItem__link stretched-link"
                        href={flattenToAppURL(item['@id'])}
                      >
                        {item.title}
                      </UniversalLink>
                    </Card.Header>

                    <ul className="list-unstyled mt-0">
                      <li className="mb-3">
                        <div className="eventsItem__date d-flex gap-1 align-items-center">
                          {getEventDate(item.start, item.end)}
                        </div>
                      </li>
                      <li className="d-flex align-items-center mb-3">
                        <FontAwesomeIcon className="eventsItem__icon me-2" icon={faClock} />
                        <span suppressHydrationWarning>{formatTime(item.start)}</span>
                      </li>
                      {item.location && (
                        <li className="mb-3 align-items-center d-flex">
                          <Icon name="location-outline" className="eventsItem__icon me-2" />
                          {item.location}
                        </li>
                      )}
                    </ul>

                    <div className="text-end mt-auto">
                      <FontAwesomeIcon icon={faArrowRight} />
                    </div>
                  </Card.Content>
                </Card>
              </Grid.Column>
            ))}
          </Grid.Row>
        </Grid>
      </Container>
    </div>
  );
};

export default RelatedEquipmentEvents;